import { render, staticRenderFns } from "./FieldSubTree.vue?vue&type=template&id=2637010d"
import script from "./FieldSubTree.vue?vue&type=script&lang=js"
export * from "./FieldSubTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports